/**
 * Returns a debounced version of the given value.
 * Useful for search inputs: only updates after user stops typing for `delay` ms.
 *
 * @param {T} value - Value to debounce
 * @param {number} delay - Delay in ms
 * @returns {T} Debounced value
 */
import { useState, useEffect } from 'react';

export function useDebouncedValue(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
